import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export const TemplatesDialog = ({ open, onClose }) => {
  const [data, setData] = useState(null);
  const [key, setKey] = useState("accesso");
  const [f, setF] = useState({ subject: "", body: "" });
  const load = (k = key) => api.get("/privacy/templates").then((r) => { setData(r.data); const t = r.data.templates.find((x) => x.key === k); setF({ subject: t.subject, body: t.body }); }).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { if (open) load(); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const pick = (k) => { setKey(k); const t = data.templates.find((x) => x.key === k); setF({ subject: t.subject, body: t.body }); };
  const save = async () => { try { await api.put(`/privacy/templates/${key}`, f); toast.success("Modello salvato"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const reset = async () => { if (!window.confirm("Ripristinare il testo predefinito di questo modello?")) return; await api.delete(`/privacy/templates/${key}`).catch(() => {}); toast.success("Testo predefinito ripristinato"); load(); };
  const cur = data?.templates.find((x) => x.key === key);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] max-w-4xl overflow-y-auto" data-testid="templates-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Modelli di risposta</DialogTitle></DialogHeader>
        {data && <div className="grid gap-4 sm:grid-cols-[200px_1fr]">
          <div className="flex flex-col gap-1">
            {data.templates.map((t) => (
              <button key={t.key} type="button" onClick={() => pick(t.key)} data-testid={`template-pick-${t.key}`}
                className={`border px-3 py-2 text-left text-sm transition-colors ${t.key === key ? "border-foreground bg-foreground text-background" : "bg-white hover:bg-muted"}`}>
                {t.label}{t.custom && <span className="ml-1 text-[10px] uppercase opacity-70">· modificato</span>}
              </button>
            ))}
          </div>
          <div className="space-y-3">
            <div><Label className="micro-label">Oggetto</Label><Input className="mt-1" value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} data-testid="template-subject" /></div>
            <div><Label className="micro-label">Testo</Label><Textarea className="mt-1 font-mono text-xs" rows={16} value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} data-testid="template-body" /></div>
            <p className="text-xs text-muted-foreground">Campi compilati in automatico: {Object.entries(data.placeholders).map(([k, v]) => `${k} ${v}`).join(" · ")}. Le parti tra [parentesi quadre] vanno completate prima dell'invio.</p>
            <div className="flex gap-2">
              <Button onClick={save} data-testid="template-save-button">Salva modello</Button>
              {cur?.custom && <Button variant="ghost" onClick={reset} data-testid="template-reset-button">Ripristina testo predefinito</Button>}
            </div>
          </div>
        </div>}
      </DialogContent>
    </Dialog>
  );
};
